let baseUrl = "https://api.utilityfielding.com"

export {
    baseUrl
}